// Load analytics only after Shopify permits analytics processing.
class SClarityAnalytics extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.loaded = false;
    const syncConsent = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return;
      const allowed = privacy.analyticsProcessingAllowed();
      if (!allowed && !this.loaded) return;
      window.clarity = window.clarity || function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      window.clarity('consentv2', {
        analytics_Storage: allowed ? 'granted' : 'denied',
        ad_Storage: 'denied',
      });
      if (!allowed || this.loaded) return;
      if (!/^[a-z0-9]+$/i.test(this.dataset.projectId || '')) return;
      this.loaded = true;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/' + this.dataset.projectId;
      this.append(script);
    };
    document.addEventListener('visitorConsentCollected', syncConsent, { signal: this.controller.signal });
    if (window.Shopify?.customerPrivacy) {
      syncConsent();
    } else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        if (!error && this.isConnected) syncConsent();
      });
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('s-clarity-analytics')) {
  customElements.define('s-clarity-analytics', SClarityAnalytics);
}
